<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="ch2">
<div class="chapterHead"><p class="centerImage"><img alt="image" src="images/ch2.jpg" width="5%"/></p>
</div>
<p class="para" style="text-indent: 5%;">On the bus, you rush to the back. You and Liz take a two-seater. Jake sits alone across the aisle with his red-sneakered feet on the seat. Now no one else can sit there.</p>
<p class="para" style="text-indent: 5%;">Jake leans back. His chin-length brown hair falls over the top of the seat. “Let’s get this crate rolling,” he mutters.</p>
<p class="para" style="text-indent: 5%;">“All right, people,” Mr. Dunning shouts from the front of the bus. “Thanks to my personal donation to the museum, we get to see the place before it opens to the public tomorrow.” The teacher does one last head count. “All right, Sal,” he says to the driver. “We’re all here. Let’s go.”</p>
<p class="para" style="text-indent: 5%;">As soon as the bus starts moving, Jake presses his nose and open lips flat against the window for the viewing pleasure of other people on the road. Then he breathes on the window and writes in the steam, <span class="smallCaps">HONK IF YOU HATE HISTORY</span>!</p>
<p class="para" style="text-indent: 5%;">“Honk!” you say, laughing.</p>
<p class="para" style="text-indent: 5%;">“Honk, honk!” Liz adds. You and Liz are honking so loud you don’t see Mr. Dunning coming down the aisle. He looks mad.</p>
<p class="extractLetterText" style="text-indent: 5%;"><em class="italic">Go to <a href="#/e9780545841733_ch003">PAGE 3</a>.</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9780545841733_ch002.vue?2ca80c04